<template>
  <div class="parent mb-8">
    <div class="mt-4 mb-7">
      <button class="export-btn" @click="openAddVacancy = !openAddVacancy">
        <template v-if="!openAddVacancy">
          Bewerber einer Stelle zuweisen
        </template>
        <template v-else>
          Stellenzuweisung schließen
        </template>
      </button>
    </div>
    <div v-if="openAddVacancy">
      <div class="vx-row mt-3">
        <div class="vx-col w-full lg:w-8/12">
          <DataInput
            v-model="vacancy"
            type="model"
            :reduce="value => value"
            model-fields="project{id}"
            placeholder="Stelle auswählen"
            name="vacancy"
            model-label="title"
            gql-query="vacancyPage"
            gql-filter-type="objectFilter"
            object-filter-attribute="searchQuery"
            allow-null
          />
        </div>
        <div class="vx-col w-full lg:w-4/12">
          <vs-button :class="{ saturated: vacancy }" @click="addVacancy()">
            Hinzufügen
            <i class="fas fa-plus"></i>
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataInput from "@/components/ui/DataInput";
import gql from "graphql-tag";
export default {
  components: {
    DataInput
  },
  props: ["applicantID"],
  emits: ["applicantVacanciesChanged"],
  data() {
    return {
      vacancy: null,
      openAddVacancy: false
    };
  },
  methods: {
    addVacancy() {
      if (this.vacancy != null) {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation(
                $applicantId: ID!
                $application: CreateApplicantApplicationInput!
              ) {
                applyToVacancy(
                  applicantId: $applicantId
                  application: $application
                ) {
                  id
                }
              }
            `,
            variables: {
              applicantId: this.applicantID,
              application: {
                vacancyID: this.vacancy.id,
                applicantID: this.applicantID,
                projectID: this.vacancy.project.id
              }
            }
          })
          .then(() => {
            this.$emit("applicantVacanciesChanged");
          });

        this.vacancy = null;
      }
    }
  }
};
</script>
